// src/App.js
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeColorProvider } from "./context/ThemeColorContext";
import { StaticTextProvider } from "./context/StaticTextContext"; 
import AppLayout from "./components/AppLayout";
import Home from "./pages/Home";

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <ThemeColorProvider>
          <StaticTextProvider> 
            <AppLayout>
              <Home />
            </AppLayout>
          </StaticTextProvider>
        </ThemeColorProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
